'use strict';
var carswip = carswip || {};
const sitenavigationOpenIcon = document.getElementById('js-site-navigation-open-icon');
const siteNavigation = document.getElementById('js-site-navigation');
const siteNavigationItems = document.getElementsByClassName('js-site-navigation-item');
carswip.sitenavigation = carswip.sitenavigation || function () {
	function init() {
		if(sitenavigationOpenIcon) {
			sitenavigationOpenIcon.addEventListener('click', function() {
				siteNavigation.classList.toggle('site-navigation--open');
				sitenavigationOpenIcon.classList.toggle('site-navigation__open-icon--open');
			});
		}
		if(siteNavigationItems) {
			for (let i = 0; i < siteNavigationItems.length; i++) {
				const currentItem = siteNavigationItems[i];
				currentItem.addEventListener('click', function(){
					siteNavigation.classList.remove('site-navigation--open');
					sitenavigationOpenIcon.classList.remove('site-navigation__open-icon--open');
				});
			}
		}
	}
	return {
		init : init
	};

}();